/**
 * janelaPromocao.ts — a frase de validade que o apostador lê na promoção.
 *
 * Spec e o porquê no topo de `__tests__/janelaPromocao.test.ts`. Gêmeo declarado do painel
 * (`Sync-ai/artifacts/synccx-portal/src/lib/promocaoJanelaTexto.ts`) — mesmas frases, testes
 * espelhados, porque são dois bundles em repos separados.
 *
 * Sem `Intl` e sem biblioteca de data: o bundle roda no navegador do site da marca, e cada
 * dependência nova aqui é risco de runtime numa tela que não tem staging.
 */

/** O servidor manda ISO. Qualquer outra coisa vira "não há frase", nunca "Invalid Date" na tela. */
function paraData(v?: string | null): Date | null {
    if (!v) return null;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** Getters LOCAIS: "até 23:59" tem de ser 23:59 no relógio do apostador. */
function formatar(d: Date): string {
    const p2 = (n: number) => String(n).padStart(2, "0");
    return `${p2(d.getDate())}/${p2(d.getMonth() + 1)}/${d.getFullYear()} às ${p2(
        d.getHours()
    )}:${p2(d.getMinutes())}`;
}

export function janelaParaApostador(inicio?: string | null, fim?: string | null): string | null {
    const i = paraData(inicio);
    const f = paraData(fim);
    if (i && f) return `Válida de ${formatar(i)} até ${formatar(f)}`;
    if (i) return `Válida a partir de ${formatar(i)}`;
    if (f) return `Válida até ${formatar(f)}`;
    return null;
}
